import i18n from "./i18n";


const languageSuffixes = {
    pl: ["_pl", ""],
    en: ["_en", "_ang"],
    es: ["_es", "_spa"],
};



/** @memberOf useHelper
 * @name TranslationFromJson()
 * @see translationFromJson()*/
export const TranslationFromJson = (json, key, i18n) => {
    const currentLanguage = i18n?.language || "pl";
    // console.log(json, languageSuffixes, i18n, i18n.language, currentLanguage)
    if (!json) return;
    return json[key + languageSuffixes[currentLanguage].find((suffix) => json[key + suffix])] || json[key];
};


/**
 * Helper function
 * @component
 * @category . Common
 * */
export const useHelper = () => {
    
    const translationFromJson = (json, key) => TranslationFromJson(json, key, i18n);

    return {
        translationFromJson,
    };
};

export default useHelper;
